{
  "COMPONENTS": {
    "MAIN_APP_BAR": {
      "LOGO": "Mankiewicz"
    },
    "MAIN_FOOTER": {
      "LINKS": {
        "IMPRINT": {
          "LABEL": "Impressum",
          "URL": "https://www.mankiewicz.com/de/impressum/"
        },
        "DATA_PROTECTION": {
          "LABEL": "Datenschutz",
          "URL": "https://www.mankiewicz.com/de/datenschutz/"
        },
        "COOKIE_SETTINGS": {
          "LABEL": "Cookie-Einstellungen"
        }
      }
    },
    "LOGOUT_BUTTON": {
      "LABEL": "Abmelden"
    },
    "LOGIN_BUTTON": {
      "LABEL": "Sign in"
    },
    "LANGUAGE_SWITCH": {
      "LABEL": "Sprache wechseln",
      "DIALOG": {
        "TITLE": "Sprache auswählen",
        "SAVE": "Speichern",
        "CANCEL": "Abbrechen"
      }
    },
    "FLAG_ICON": {
      "ARIA_LABEL": "Flagge für {locale}"
    },
    "FILTER_MENU": {
      "TITLE": "Filter",
      "TOGGLE_BUTTON": "Filter",
      "CLOSE_BUTTON_TOP_LABEL": "Filter schließen",
      "CLOSE_BUTTON_BOTTOM_LABEL": "Filter anwenden"
    },
    "HEADER": {
      "RESET_BUTTON": "Alle Filter zurücksetzen",
      "RESET_DOCUMENTS_SELECTION_BUTTON": "Dokumentenauswahl zurücksetzen"
    },
    "MAIL_RECIPIENTS_INPUT": {
      "LABEL": "Empfänger*innen",
      "PLACEHOLDER": "Bitte E-Mail-Adresse(n) angeben",
      "MESSAGE": "Beispiel: \"name{'@'}example.com\""
    }
  },
  "VIEWS": {
    "PUBLIC": {
      "ERROR_PAGE": {
        "TITLE": "Es ist ein Fehler aufgetreten",
        "MESSAGE": "Entschuldigung, etwas ist schief gelaufen. Bitte versuchen Sie es später erneut.",
        "BUTTON_BACK_LABEL": "Zurück",
        "BUTTON_HOME_LABEL": "Zur Startseite"
      },
      "PAGE_NOT_FOUND": {
        "TITLE": "Seite nicht gefunden",
        "MESSAGE": "Die von Ihnen angeforderte Seite konnte leider nicht gefunden werden.",
        "BUTTON_BACK_LABEL": "Zurück",
        "BUTTON_HOME_LABEL": "Zur Startseite"
      },
      "PAGE_NOT_ALLOWED": {
        "TITLE": "Zugriff verweigert",
        "MESSAGE": "Sie haben für die von ihnen angeforderte Seite keinen Zugriff.",
        "BUTTON_BACK_LABEL": "Zurück",
        "BUTTON_HOME_LABEL": "Zur Startseite"
      }
    },
    "RESTRICTED": {
      "LOGIN_ERROR": {
        "TITLE": "Anmeldung nicht möglich",
        "MESSAGE": "Der Anmeldeserver ist aktuell nicht erreichbar. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
        "BUTTON_RETRY_LABEL": "Erneut versuchen"
      },
      "DOCUMENT_LIST": {
        "HEADER": {
          "DOWNLOAD_DOCUMENTS_BUTTON": {
            "LABEL": "Auswahl herunterladen/versenden ({count})",
            "LIMIT_MESSAGE": "Sie haben {count} von maximal {max} Dokumenten ausgewählt."
          }
        },
        "RESULTS": {
          "TABLE_HEADERS": {
            "PRODUCT_NAME": "Produktname",
            "IS_NEW": "",
            "PRODUCT_NUMBER": "Produktnummer",
            "PRODUCT_PART_NUMBER": "Part number",
            "DESCRIPTION": "Beschreibung",
            "LEGAL_AREA": "Rechtsraum",
            "LANGUAGE": "Sprache",
            "TYPE": "Typ",
            "ACTIONS": "Download"
          },
          "TABLE_FOOTER": {
            "TOTAL_COUNT": "Keine Ergebnisse | Ein Ergebnis | {count} Ergebnisse",
            "NEXT_PAGE": "Nächste Seite",
            "PREVIOUS_PAGE": "Vorherige Seite",
            "ITEMS_PER_PAGE": "Einträge pro Seite",
            "CURRENT_PAGE": "Seite {currentPage} von {totalPages}"
          },
          "ITEM": {
            "IS_NEW": "Neu",
            "DOWNLOAD_ERROR_TOOLTIP": "Download fehlgeschlagen. Bitte erneut versuchen."
          }
        },
        "FILTER": {
          "COMMON": {
            "TITLE": "Filter",
            "PLACEHOLDER": "Auswählen"
          },
          "TEXT_SEARCH": {
            "LABEL": "Produktsuche",
            "PLACEHOLDER": "Suchen Sie Ihr Produkt"
          },
          "LEGAL_AREA": {
            "LABEL": "Rechtsraum"
          },
          "DOCUMENT_LANGUAGE": {
            "LABEL": "Dokumentensprache"
          },
          "DOCUMENT_TYPE": {
            "LABEL": "Dokumententyp"
          },
          "PRODUCT_COLOR": {
            "LABEL": "Produktfarbe"
          },
          "PRODUCT_GLOSS_LEVEL": {
            "LABEL": "Glanzgrad"
          },
          "DOCUMENT_CREATION_DATE": {
            "LABEL": "Erstellungsdatum"
          },
          "DOCUMENT_IS_NEW_FOR_CLIENT": {
            "LABEL": "Neue Dokumente zeigen"
          }
        }
      },
      "DOCUMENTS_DOWNLOAD": {
        "BUTTON_LABEL_DOCUMENT_SELECTION": "Zurück zur Dokumentensuche",
        "LIST": {
          "HEADLINE": "Hallo {name} - Sie haben {count} Dokumente ausgewählt.",
          "TEXT": "Ihre ausgewählten Dokumente wurden in einer ZIP-Datei gepackt. Der Download-Link ist 24 Stunden gültig.",
          "BACK_BUTTON": {
            "LABEL": "Zurück zur Auswahl"
          },
          "MAIL_BUTTON": {
            "LABEL": "Via E-Mail senden"
          },
          "DOWNLOAD_BUTTON": {
            "LABEL": "Download {fileSize} MB"
          }
        },
        "SEND_MAIL": {
          "TITLE": "Geben Sie zusätzliche Empfänger*innen an, um den Download-Link an andere zu senden.",
          "SEND_BUTTON": {
            "LABEL": "Senden"
          },
          "GO_BACK_BUTTON": {
            "LABEL": "Zurück"
          }
        },
        "SEND_MAIL_SUCCESS": {
          "TITLE": "Hallo {name},\nIhre Auswahl wurde erfolgreich gesendet.",
          "TEXT": "Die ZIP-Datei mit den ausgewählten Dokumenten wird in Kürze\nan Ihre E-Mail-Adresse und alle angegebenen Empfänger*innen zugestellt."
        },
        "SEND_MAIL_FAILURE": {
          "TITLE": "Hallo {name},\nIhre Auswahl konnte nicht gesendet werden.",
          "TEXT": "Beim Versenden der ZIP-Datei mit den ausgewählten Dokumenten\nist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
          "GO_BACK_BUTTON": {
            "LABEL": "Erneut versuchen"
          }
        }
      }
    }
  },
  "validations": {
    "required": "Bitte ausfüllen!",
    "email": "Bitte eine gültige E-Mail-Adresse angeben!",
    "maxLength": "Bitte nicht mehr als {max} Zeichen angeben!",
    "minLength": "Bitte nicht weniger als {min} Zeichen angeben!",
    "integer": "Bitte nur Zahlen angeben!",
    "requiredIf": "Bitte ausfüllen!",
    "emailArray": "Bitte gültige E-Mail-Adressen angeben!",
    "customerExists": "Ein Kunde mit dieser Kundennummer existiert bereits!"
  }
}